import { app } from 'apprun';
import { __, lang } from '../Txlat';
import { $ } from '../utility';
import { getPropertyDetailStatusPrice } from '../model/property';

function normalizeUrl(url: string): string {
  // Trim whitespace
  url = url.trim();

  // Default to https:// if no protocol is present
  if (!url.toLowerCase().startsWith('http://') && !url.toLowerCase().startsWith('https://') && !url.toLowerCase().startsWith('file://')) {
    return `https://${url}`;
  }

  return url;
}

export default function ({ property, features }) {
  if (!property) { return; }

  const statusPrice = getPropertyDetailStatusPrice(property);

  $('.page-title').innerHTML = `<h1>${property.address}</h1>${property.city}&nbsp;&nbsp;${property.province}&nbsp;&nbsp;${property.postal_code}<br>MLS®${property.mls_id}`;

  $('.item-price.item-price-text.price-single-listing-text').innerHTML = statusPrice.price;
  $('#property-status').innerHTML = statusPrice.status;

  return (
    <div class="property-view">

      <div class="visible-on-mobile">
        <div class="mobile-top-wrap">
          <div class="mobile-property-tools clearfix">
            <ul class="nav nav-pills houzez-media-tabs-4" id="pills-tab" role="tablist">

              <li class="nav-item">
                <a class="nav-link active" id="pills-gallery-tab" data-toggle="pill" href="#pills-gallery" role="tab" aria-controls="pills-gallery" aria-selected="true">
                  <i class="houzez-icon icon-picture-sun"></i>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link " id="pills-map-tab" data-toggle="pill" href="#pills-map" role="tab" aria-controls="pills-map" aria-selected="true">
                  <i class="houzez-icon icon-maps"></i>
                </a>
              </li>
            </ul>
            <ul class="item-tools">

              <li class="item-tool houzez-share">
                <span class="item-tool-share dropdown-toggle" data-toggle="dropdown">
                  <i class="houzez-icon icon-share"></i>
                </span>
                <div class="dropdown-menu dropdown-menu-right item-tool-dropdown-menu">

                  <a class="dropdown-item" target="_blank" href={`https://api.whatsapp.com/send?text=${__('Detail')}&nbsp;${window.location.href}`}>
                    <i class="houzez-icon icon-messaging-whatsapp mr-1"></i> WhatsApp</a>

                  <a class="dropdown-item" href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURI(window.location.href)}`} onclick="window.open(this.href, 'mywin','left=50,top=50,width=600,height=350,toolbar=0'); return false;">
                    <i class="houzez-icon icon-social-media-facebook mr-1"></i> Facebook
                  </a>
                  <a class="dropdown-item" href={`https://twitter.com/intent/tweet?text=${__('Detail')}&amp;url=${encodeURI(window.location.href)}`} onclick="if(!document.getElementById('td_social_networks_buttons')){window.open(this.href, 'mywin','left=50,top=50,width=600,height=350,toolbar=0'); return false;}">
                    <i class="houzez-icon icon-social-media-twitter mr-1"></i> Twitter
                  </a>
                  <a class="dropdown-item" href={`https://pinterest.com/pin/create/button/?url=${encodeURI(window.location.href)}&amp;media=${encodeURI(window.location.href)}`} onclick="window.open(this.href, 'mywin','left=50,top=50,width=600,height=350,toolbar=0'); return false;">
                    <i class="houzez-icon icon-social-pinterest mr-1"></i> Pinterest
                  </a>
                  <a class="dropdown-item" href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURI(window.location.href)}`} onclick="window.open(this.href, 'mywin','left=50,top=50,width=600,height=350,toolbar=0'); return false;">
                    <i class="houzez-icon icon-professional-network-linkedin mr-1"></i> Linkedin
                  </a>
                </div>
              </li>

              <li class="item-tool houzez-print" data-propid="448">
                <span class="item-tool-compare">
                  <i class="houzez-icon icon-print-text"></i>
                </span>
              </li>
            </ul>
          </div>

          <div class="block-wrap">
            <div class="block-content-wrap"><b>{property.address}</b></div>
            <div class="block-content-wrap">{property.city}&nbsp;&nbsp;{property.province}&nbsp;&nbsp;{property.postal_code}</div>
            <div class="block-content-wrap">MLS®{property.mls_id}</div>
            <div class="block-content-wrap"><b>{statusPrice.price}</b></div>
            <div class="block-content-wrap">{statusPrice.status}</div>
          </div>

        </div>
      </div>

      <div class="property-overview-wrap property-section-wrap" id="property-overview-wrap">

        {property.mediaLinks && property.mediaLinks.length > 0 && (
          <div class="block-wrap">
            <div class="block-title-wrap"><h2>{__('Multimedia')}</h2></div>
            <div style="display: flex; flex-wrap: wrap; justify-content: left; gap: 2rem; text-align: center;">
              {property.mediaLinks && property.mediaLinks.map((link, index) => {
                const icons = {
                  VRTOUR: {
                    path: 'M213.1 64.8L202.7 96 128 96c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-74.7 0L426.9 64.8C420.4 45.2 402.1 32 381.4 32L258.6 32c-20.7 0-39 13.2-45.5 32.8zM448 256c0 8.8-7.2 16-16 16l-76.7 0c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8L371 229c-13.6-13.4-31.9-21-51-21c-19.2 0-37.7 7.6-51.3 21.3L249 249c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l19.7-19.7C257.4 172.7 288 160 320 160c31.8 0 62.4 12.6 85 35l23.7-23.7c2.1-2.1 5-3.3 8-3.3c6.2 0 11.3 5.1 11.3 11.3l0 76.7zM192 320c0-8.8 7.2-16 16-16l76.7 0c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8L269 347c13.6 13.4 31.9 21 51 21c19.2 0 37.7-7.6 51.3-21.3L391 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-19.7 19.7C382.6 403.3 352 416 320 416c-31.8 0-62.4-12.6-85-35l-23.7 23.7c-2.1 2.1-5 3.3-8 3.3c-6.2 0-11.3-5.1-11.3-11.3l0-76.7z',
                    label: __('Virtual Tours'),
                    viewBox: '0 0 640 512',
                  },
                  AUDIO: {
                    path: 'M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zm2 226.3c37.1 22.4 62 63.1 62 109.7s-24.9 87.3-62 109.7c-7.6 4.6-17.4 2.1-22-5.4s-2.1-17.4 5.4-22C269.4 401.5 288 370.9 288 336s-18.6-65.5-46.5-82.3c-7.6-4.6-10-14.4-5.4-22s14.4-10 22-5.4zm-91.9 30.9c6 2.5 9.9 8.3 9.9 14.8l0 128c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L113.4 376 80 376c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16l33.4 0 35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5zm51 34.9c6.6-5.9 16.7-5.3 22.6 1.3C249.8 304.6 256 319.6 256 336s-6.2 31.4-16.3 42.7c-5.9 6.6-16 7.1-22.6 1.3s-7.1-16-1.3-22.6c5.1-5.7 8.1-13.1 8.1-21.3s-3.1-15.7-8.1-21.3c-5.9-6.6-5.3-16.7 1.3-22.6z',
                    label: __('Audio'),
                    viewBox: '0 0 384 512',
                  },
                  VIDEO: {
                    path: 'M0 128C0 92.7 28.7 64 64 64l256 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2l0 256c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1l0-17.1 0-128 0-17.1 14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z',
                    label: __('Video'),
                    viewBox: '0 0 576 512',
                  },
                  SLIDESHOW: {
                    path: 'M187.7 153.7c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7s61.7-26 61.7-57.7c0-32-27.7-57.7-61.7-57.7zm143.4 0c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7 34.3 0 61.7-26 61.7-57.7 .1-32-27.4-57.7-61.7-57.7zm156.6 90l-6 4.3V49.7c0-27.4-20.6-49.7-46-49.7H76.6c-25.4 0-46 22.3-46 49.7V248c-2-1.4-4.3-2.9-6.3-4.3-15.1-10.6-25.1 4-16 17.7 18.3 22.6 53.1 50.3 106.3 72C58.3 525.1 252 555.7 248.9 457.5c0-.7 .3-56.6 .3-96.6 5.1 1.1 9.4 2.3 13.7 3.1 0 39.7 .3 92.8 .3 93.5-3.1 98.3 190.6 67.7 134.3-124 53.1-21.7 88-49.4 106.3-72 9.1-13.8-.9-28.3-16.1-17.8zm-30.5 19.2c-68.9 37.4-128.3 31.1-160.6 29.7-23.7-.9-32.6 9.1-33.7 24.9-10.3-7.7-18.6-15.5-20.3-17.1-5.1-5.4-13.7-8-27.1-7.7-31.7 1.1-89.7 7.4-157.4-28V72.3c0-34.9 8.9-45.7 40.6-45.7h317.7c30.3 0 40.9 12.9 40.9 45.7v190.6z',
                    label: __('Slideshows'),
                    viewBox: '0 0 512 512',
                  },
                  BROCHURE: {
                    path: 'M249.6 471.5c10.8 3.8 22.4-4.1 22.4-15.5l0-377.4c0-4.2-1.6-8.4-5-11C247.4 52 202.4 32 144 32C93.5 32 46.3 45.3 18.1 56.1C6.8 60.5 0 71.7 0 83.8L0 454.1c0 11.9 12.8 20.2 24.1 16.5C55.6 460.1 105.5 448 144 448c33.9 0 79 14 105.6 23.5zm76.8 0C353 462 398.1 448 432 448c38.5 0 88.4 12.1 119.9 22.6c11.3 3.8 24.1-4.6 24.1-16.5l0-370.3c0-12.1-6.8-23.3-18.1-27.6C529.7 45.3 482.5 32 432 32c-58.4 0-103.4 20-123 35.6c-3.3 2.6-5 6.8-5 11L304 456c0 11.4 11.7 19.3 22.4 15.5z',
                    label: __('Brochures'),
                    viewBox: '0 0 576 512',
                  },
                  WEB_COMM: {
                    path: 'M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z',
                    label: __('Web Commercials'),
                    viewBox: '0 0 576 512',
                  },
                  ADD_PHOTO: {
                    path: 'M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l96 0 32 0 208 0c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z',
                    label: __('Additional Photos'),
                    viewBox: '0 0 512 512',
                  },
                  MAP: {
                    path: 'M384 476.1L192 421.2l0-385.3L384 90.8l0 385.3zm32-1.2l0-386.5L543.1 37.5c15.8-6.3 32.9 5.3 32.9 22.3l0 334.8c0 9.8-6 18.6-15.1 22.3L416 474.8zM15.1 95.1L160 37.2l0 386.5L32.9 474.5C17.1 480.8 0 469.2 0 452.2L0 117.4c0-9.8 6-18.6 15.1-22.3z',
                    label: __('Map'),
                    viewBox: '0 0 576 512',
                  },
                  FLOOR: {
                    path: 'M48 0C21.5 0 0 21.5 0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 96 0c26.5 0 48-21.5 48-48l0-416c0-26.5-21.5-48-48-48L48 0zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z',
                    label: __('Floorplan'),
                    viewBox: '0 0 384 512',
                  },

                };

                const icon = icons[link.type] || {};

                return (
                  <div
                    key={index}
                    style={{
                      flex: '0 1 100px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                  >
                    <a href={normalizeUrl(link.link)} target='_blank'>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox={icon.viewBox}
                        style={{
                          fill: '#ea002a',
                          width: '30px',
                          height: '30px',
                          margin: '0 0 .625rem',
                        }}
                      >
                        <path d={icon.path} />
                      </svg>
                    </a>

                    <a href={normalizeUrl(link.link)} target='_blank'><span style={{ fontSize: '1rem', color: '#333' }}>{icon.label}</span></a>

                  </div>
                );
              })}

            </div>
          </div>)}

        <div class="block-wrap">
          <div class="block-title-wrap"><h2>{__('Description')}</h2></div>
          <div class="block-content-wrap"><p>{lang.get() === 'fr' ? property.description_fr : property.description}</p></div>
        </div>

        <div class="block-wrap">
          {features ?
            <div class="block-title-wrap d-flex justify-content-between align-items-center">
              <h2>{__('Features')}</h2>
            </div> : ''
          }
          <div class="block-content-wrap">
            <ul class="list-1-cols list-unstyled">
              {
                features?.map((item) => {
                  return (<li><strong>{item.key}</strong> <span>{item.value}</span></li>);
                })
              }
            </ul>
          </div>
          <div>
            <p></p>
            {
              property.rlp === 'false' ?<p>{__('Courtesy of') + ': ' + property.broker}</p> : ''
            }
            <p></p>
            <p>
              {property.moreInformationLink?
                <a href={lang.get() === 'en' ? property.moreInformationLink : property.moreInformationLink.replace('/real-estate/','/immobilier/')} target="_blank" rel="nofollow"><img width="125" src={__('https://www.realtor.ca/images/en-ca/powered_by_realtor.svg')}/></a>
                : <img width="125" src={__('https://www.realtor.ca/images/en-ca/powered_by_realtor.svg')} />
              }
            </p>

          </div>

        </div>
      </div>
    </div>

  );
}
